module.exports = __webpack_public_path__ + "static/media/2017 - 18 Kenny Lee-min.b97e07a1.jpg";